module.exports = __webpack_public_path__ + "img/abstract-colorful-flow-shapes-background.990df597.jpg";